import { createFileRoute } from '@tanstack/react-router';

import { PhotosPage } from '@/features/owner/photos-page';

export const Route = createFileRoute('/_app/projects/$projectId/timeline/photos')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <PhotosPage projectId={projectId} />;
}
